export const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

export const periodsPerYear = {
  weekly: 52,
  fortnightly: 26,
  bimonthly: 24,
  monthly: 12,
  every_second_month: 6,
  quarterly: 4,
  yearly: 1,
}

export const addUpdateCssRule = (selectorText: string, ruleBody: string) => {
  // e.g. selectorText = '.BillSavingsChart .NewBill .ct-bar'
  // ruleBody =  '{ stroke: #0F0; }'
  //
  // Notice: This works around CORS access/update issues when updating a CSS file stored
  // on filesystem, e.g. when app is embedded on iOS filesystem.
  // This method is not subject to this constraint and can be used to both
  // add a new rule and update it too.

  var style = document.getElementById(selectorText)

  if (style) {
    style.innerHTML = selectorText + ' ' + ruleBody
  } else {
    style = document.createElement('style')
    // @ts-ignore TODO: .type is not an attribute on DOMElement
    style.type = 'text/css'

    //tag with id in case we want to update it again later
    style.id = selectorText
    style.innerHTML = selectorText + ruleBody
    document.getElementsByTagName('head')[0].appendChild(style)
  }
}

export const titleCase = (str: string) => str && str.replace(/\b\S/g, (t) => t.toUpperCase())

export const formatCurrency = (value?: string | number | null) => {
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  return (value ? value : 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

interface SystemDataLike {
  uuid: string
  data: {
    uuid: string
  }
  attached_phoenix_payment_option: any
}

interface ProposalDataLike {
  selectedProject: {
    proposal_data: {
      systems: SystemDataLike[]
    }
  }
  /** Undefined for Non-Solar Proposal V2 (no Studio-backed system in `project.design`). */
  selectedSystem?: SystemDataLike
}

export const checkHasPhoenixPaymentOption = (proposalData: ProposalDataLike) => {
  return !!proposalData?.selectedProject?.proposal_data?.systems?.find(
    (sys) => sys?.data?.uuid === proposalData?.selectedSystem?.uuid
  )?.attached_phoenix_payment_option
}

// Copied utils from Designer.js
export const convertLocaleName = (locale) => {
  if (!locale || !locale.includes) {
    return locale
  } else if (!locale.includes('_')) {
    return locale
  } else {
    const parts = locale.split('_')
    return `${parts[0]}-${parts[1]}`
  }
}

export const formatCurrencyNumber = (value, places, locale?: string, hideZero = false) => {
  if (hideZero && value === 0) return ' - '
  if (!places && places !== 0) {
    places = 2
  }
  locale = convertLocaleName(locale)

  return new Intl.NumberFormat(locale, { minimumFractionDigits: places, maximumFractionDigits: places }).format(
    value ? value : 0
  )
}

export const formatCurrencyWithSymbol = (value, currencySymbol, locale?, places?, hideZero = false) => {
  if (currencySymbol === '€') {
    if (['en', 'en-us'].includes(locale)) {
      // Beware language us lowercase like en-us not en-US
      return '€' + formatCurrencyNumber(value, places, locale, hideZero)
    } else {
      return formatCurrencyNumber(value, places, locale, hideZero) + ' €'
    }
  } else {
    return currencySymbol + formatCurrencyNumber(value, places, locale, hideZero)
  }
}
// end Copied utils from Designer.js

// copied from spa/studio/src/Utils.js
export function roundToDecimalPlaces(value, places, lang = 'en') {
  /*
  Beware: This is for formatting to string for readability NOT mathematical
  usage:
  var number = 123456.789;
  number.toLocaleString('de-DE')
  '123.456,789'
  number.toLocaleString('de')
  '123.456,789'
  number.toLocaleString('it')
  '123.456,789'
  number.toLocaleString('es')
  '123.456,789'
  number.toLocaleString('en-in')
  '1,23,456.789'
  */

  // change en_US to en-US for Number.prototype.toLocaleString
  lang = lang.replace('_', '-')

  try {
    if (places === 0) {
      return Math.round(value).toLocaleString(lang)
    } else if (!places) {
      return value.toLocaleString(lang)
    }

    var factor = Math.pow(10, places)
    var result = Math.round(value * factor) / factor
    return result.toLocaleString(lang)
  } catch (err) {
    return '--'
  }
}

export const toYearsAndMonths = (years_decimal: number) => {
  const tmp = {
    years: Math.floor(years_decimal),
    months: Math.ceil((years_decimal - Math.floor(years_decimal)) * 12),
  }
  if (tmp.months === 12) {
    tmp.years += 1
    tmp.months = 0
  }
  return tmp
}
